import Component, { Topic } from 'component';

customElements.define(
    'x-cart-indicator',
    class extends Component {
        constructor() {
            super();
        }

        render() {
            this.sub(
                Topic.CART_UPDATE,
                ({ data }) => {
                    if (!data) return;

                    const itemCount = Number(data.itemCount) || 0;

                    this.textContent = itemCount;
                    this.toggleAttribute('hidden', itemCount < 1);
                },
                { global: true }
            );
        }
    }
);